export enum OnboardingStep {
  AccountingManagement = 'accounting-management',
  Intent = 'intent',
  Invoices = 'invoices',
  NamePhone = 'name-phone',
  WorkStyle = 'work-style',
}
